import { Outlet } from 'react-router-dom';

import { Header } from './Header';

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="py-4 text-center text-sm text-zinc-500">
        <p>사주포춘 &copy; {new Date().getFullYear()}</p>
        <p className="mt-1 text-xs">본 서비스는 오락 목적으로 제공됩니다.</p>
      </footer>
    </div>
  );
}
